export class CheckboxTreeNode {
  constructor(
    public id: number,
    public label: string,
    public state: CheckboxState = 'unchecked',
    public isExpanded: boolean = false,
    public children?: CheckboxTreeNode[],
    public parentId?: number,
    public count?: number,
    public industryCode?: string
  ) {}
}

export type CheckboxState = 'checked' | 'unchecked' | 'indeterminate' | 'disabled';
